import Vue from "vue";
import i18n from "./i18n";
import App from "./App.vue";

Vue.config.productionTip = false;
Vue.config.devtools = false;

const defaultshowkeywords = true;
const defaultfilteryear = true;
const defaultfiltergroupids = "";
const defaultparentid = -1;
const defaultpagesize = 20;
const defautresultType = "Result";
const defaultOrderBy = "created desc";

const resourceindexelement = document.getElementById("sm-resource-index");

const showkeywords =
  resourceindexelement?.getAttribute("data-showkeywords") == null
    ? defaultshowkeywords
    : resourceindexelement.getAttribute("data-showkeywords")?.toLowerCase() ===
      "true";
const filteryear =
  resourceindexelement?.getAttribute("data-filteryear") == null
    ? defaultfilteryear
    : resourceindexelement.getAttribute("data-filteryear")?.toLowerCase() ===
      "true";
const filtergroupids =
  resourceindexelement?.getAttribute("data-filtergroupids") ??
  defaultfiltergroupids;

const resulttype =
  resourceindexelement?.getAttribute("data-resulttype") ?? defautresultType;

let parentid = defaultparentid;
const castparentid = Number(
  resourceindexelement?.getAttribute("data-parentid")
);
if (!isNaN(castparentid) && castparentid !== 0) parentid = castparentid;

let pagesize = defaultpagesize;
const castpagesize = Number(
  resourceindexelement?.getAttribute("data-pagesize")
);
if (!isNaN(castpagesize) && castpagesize !== 0) pagesize = castpagesize;

let orderBy = String(
  resourceindexelement?.getAttribute("data-orderby")
);

if(! orderBy) orderBy = defaultOrderBy;

const title = resourceindexelement?.getAttribute("data-title");
const description = resourceindexelement?.getAttribute("data-description");
const indexName = resourceindexelement?.getAttribute("data-indexname");

new Vue({
  i18n,
  render: (h) =>
    h(App, {
      props: {
        showkeywords: showkeywords,
        filtergroupids: filtergroupids,
        filteryear: filteryear,
        parentid: parentid,
        pagesize: pagesize,
        title: title,
        description: description,
        resultType: resulttype,
        indexname: indexName,
        orderBy: orderBy
      }
    })
}).$mount("#sm-resource-index");
